import type { LinkHubCustomerState } from './types/ReducerTypes';
import { INIT_STATE } from './constants/initState';
import { UPDATE_AD_LINKS } from './actions/updateAdLinks.action';
import { UPDATE_QUICK_LINKS } from './actions/updateQuickLinks.action';
import { deepCopy } from '../../../../../shared/utils';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import type { LinkHubCustomerAction } from './types/LinkHubCustomerActions';

const handler = (state: WrappedReducer<LinkHubCustomerState>, action: LinkHubCustomerAction) => {
  switch (action.type) {
    case UPDATE_AD_LINKS:
      return {
        ...state,
        adLinks: action.data?.adLinks,
      };
    case UPDATE_QUICK_LINKS:
      return {
        ...state,
        quickLinks: action.data?.quickLinks,
      };
    default:
      return state;
  }
};

const LinkHubCustomerReducer = ReduxAsyncActionsService.wrapReducer(deepCopy(INIT_STATE), handler, {});

export default LinkHubCustomerReducer;
